import React from "react";
import { withRouter } from "react-router";
import { Layout } from "antd";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { connect } from "react-redux";

import { PropertiesListing, SearchProperties } from "./Components/Properties";
import { UserSurveyListing } from "./Components/Surveys";
import { AccountSettings } from "./Components/AccountSettings";
import { TaxCollectionListing } from "./Components/TaxCollection";
import { AddInspectors, InspectorsListing } from "./Components/Inspectors";
import Sidebar from "./Components/sidebar";
import DashboardHeader from "./Components/header";
import CheckIfLoggedIn from "../../Components/CheckIfLoggedIn/CheckIfLoggedIn";
import ActivityLogs from "./Components/User/ActivityLogs";
import "./style/index.css";
import ViewProperty from "./Components/Properties/ViewProperty";
import ViewTaxCollection from "./Components/TaxCollection/ViewTaxCollection";
import PhTenForm from "./Components/Properties/Forms/PhTenForm";
import Ph1Form from "./Components/Properties/Forms/Ph1Form";
import Ph9Form from "./Components/Properties/Forms/Ph9Form";
import PhTenFormBulk from "./Components/Properties/Forms/PhTenFormBulk";
import NotificationSideBar from "./Components/Properties/notificationSidebar";
import NotificationListing from "./Components/Properties/notificationListing";
import DetectedProperties from "./Components/Properties/MLProperties/MLPropertiesListing";
import ReportsOverview from "./Components/reports";
import ReportsOverviewPdf from "./Components/Properties/Forms/ETOreportPdf";
import ZonesReports from "./Components/reports/zoneReports";
import CircleReport from "./Components/reports/circlesReport";
import ReportsTaxInspector from "./Components/reports/taxInspector";
import ZoneReportPdf from "./Components/Properties/Forms/ZoneReportPdf";
import CircleReportPdf from "./Components/Properties/Forms/CircleReportPdf";
import TIReportPdf from "./Components/Properties/Forms/TIReportPdf";
import ProofOfPayment from "./Components/TaxCollection/ProofOfPayment";
import PaidProperties from "./Components/TaxCollection/PaidProperties";
import DashboardAdmin from "./Dashboard.Admin";
import TaxCollectionDetailView from "./Components/TaxCollection/TaxCollectionDetailView";
import NoAccess from "../../Components/NoAccess";
import NoAccessDashboardHeader  from "../../Components/NoAccess/header"

const { Sider, Content, Header } = Layout;

const DashboardPage = ({ history, user, notificationToggle }) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const [minHeight, setMinHeight] = React.useState(window.innerHeight);
  const [isInspector, setIsInspector] = React.useState();
  const [isEto, setIsEto] = React.useState();
  const [isAdmin, setIsAdmin] = React.useState(null);
  const [isDistrictAdmin, setIsDistrictAdmin] = React.useState(null);
  const [adminDistrictId, setAdminDistrictId] = React.useState();

  React.useEffect(() => {
    window.onresize = (e) => {
      setMinHeight(e.target.innerHeight);
    };
  }, []);
  React.useEffect(() => {
    if (user) {
      const area = user?.currentUser?.data?.rating_area?.name;
      setIsInspector(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id == 1) >=
          0
      );
      setIsAdmin(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 3) >=
          0
        //3 being the role of Admin
      );
      setIsEto(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 2) >=
          0
      );
      setIsDistrictAdmin(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
          0
      );
      setAdminDistrictId(user?.currentUser?.data?.district?.id)
    }
  }, [user]);

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };
  return (
    <Router>
      {(isAdmin || (isDistrictAdmin && adminDistrictId) || isEto || isInspector) ? <Layout style={{ minHeight: minHeight }}>
        <Sider
          collapsible
          width="215px"
          trigger={null}
          className="side-bar"
          collapsed={collapsed}
          onCollapse={onCollapse}
        >
          <Sidebar collapsed={collapsed} />
        </Sider>
        <Layout>
          <Header className={collapsed ? "adjust" : "header-bar"}>
            <DashboardHeader onCollapse={() => onCollapse()} />
          </Header>
          <Content className={collapsed ? "adjustBoday" : "layout-content "}>
            <div className="mainWrapperDiv">
              <CheckIfLoggedIn history={history}>
                {notificationToggle && <NotificationSideBar />}
                {(isInspector || isEto) && (
                  <Switch>
                    <Route
                      exact
                      path="/"
                      render={() => <Redirect to="/properties/unregistered" />}
                    />

                    <Route exact path="/inspectors">
                      {isInspector ? (
                        <Redirect to="/tax-collection/create" />
                      ) : (
                        <InspectorsListing />
                      )}
                    </Route>
                    {/* <Route path="/inspectors/add">
                  <AddInspectors />
                </Route> */}
                    <Route exact path="/properties/view/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ViewProperty />
                      )}
                    </Route>
                    <Route exact path="/properties/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <PropertiesListing />
                      )}
                    </Route>
                    <Route exact path="/properties/ph9/:id">
                      {isInspector ? <Redirect to="/login" /> : <Ph9Form />}
                    </Route>
                    <Route exact path="/properties/ph1/:id">
                      {isInspector ? <Redirect to="/login" /> : <Ph1Form />}
                    </Route>

                    <Route exact path="/search-property/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ViewProperty />
                      )}
                    </Route>
                    <Route exact path="/detected-properties/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ViewProperty />
                      )}
                    </Route>
                    <Route path="/search-property">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <SearchProperties />
                      )}
                    </Route>
                    <Route exact path="/account-settings/:id">
                      <AccountSettings />
                    </Route>
                    <Route exact path="/surveys">
                      <UserSurveyListing />
                    </Route>
                    <Route exact path="/tax-collection/:id">
                      <TaxCollectionListing />
                    </Route>
                    <Route exact path="/tax-collection/challans">
                      <PaidProperties />
                    </Route>
                    <Route exact path="/tax-collection/view/:id">
                      <ViewTaxCollection />
                    </Route>
                    <Route exact path="/tax-collection/proof/:id">
                      <ProofOfPayment />
                    </Route>
                    <Route exact path="/tax-collection/viewform/:id">
                      <PhTenForm />
                    </Route>
                    <Route exact path="/tax-collection/detail-view/:id">
                      <TaxCollectionDetailView />
                    </Route>
                    <Route path="/ph1">
                      <PhTenForm />
                    </Route>
                    <Route path="/bulkph10">
                      <PhTenFormBulk />
                    </Route>
                    <Route path="/all-notifications">
                      {/* {isInspector ? (
                        <Redirect to="/login" />
                      ) : ( */}
                        <NotificationListing />
                      
                    </Route>
                    <Route path="/detected/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <DetectedProperties />
                      )}
                    </Route>
                    <Route path="/user/logs">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ActivityLogs />
                      )}
                    </Route>
                    <Route path="/reports/overview">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ReportsOverview />
                      )}
                    </Route>
                    <Route path="/reports/overview-pdf">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ReportsOverviewPdf />
                      )}
                    </Route>
                    <Route path="/reports/zone/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ZonesReports />
                      )}
                    </Route>
                    <Route path="/reports/circle/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <CircleReport />
                      )}
                    </Route>
                    <Route path="/reports/zone-pdf/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ZoneReportPdf />
                      )}
                    </Route>
                    <Route path="/reports/circle-pdf/:id">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <CircleReportPdf />
                      )}
                    </Route>
                    <Route path="/reports/taxInspector">
                      {isInspector ? (
                        <Redirect to="/login" />
                      ) : (
                        <ReportsTaxInspector />
                      )}
                    </Route>
                    <Route path="/reports/taxInspector-pdf/:selectedTi/circle/:selectedCircle">
                      {isInspector ? <Redirect to="/login" /> : <TIReportPdf />}
                    </Route>
                    <Route path="/">
                      {isInspector ? (
                        <Redirect to="/tax-collection/create" />
                      ) : (
                        <Redirect to="/properties/unregistered" />
                      )}
                    </Route>
                  </Switch>
                )}
                {((isAdmin !== null && isAdmin) || (isDistrictAdmin !== null && isDistrictAdmin)) && <DashboardAdmin />}
              </CheckIfLoggedIn>
            </div>
          </Content>
        </Layout>
      </Layout>: 
      <Layout>
        <Header style={{padding:0}}>
          <NoAccessDashboardHeader />
        </Header>
        <Content>
          <NoAccess/>
        </Content>
      </Layout>}
    </Router>
  );
};

const mapStateToProps = ({ user, property: { notificationToggle } }) => ({
  user,
  notificationToggle,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardPage)
);

// export default withRouter(DashboardPage);
